export default __webpack_public_path__ + "static/media/github.79b3287b.svg";